var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddScreenImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 308,
    viewBox: "0 0 308 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260.477 70.8359H110.688C105.621 70.8359 101.514 74.9432 101.514 80.0098V199.721C101.514 204.787 105.621 208.895 110.688 208.895H260.477C265.543 208.895 269.65 204.787 269.65 199.721V80.0098C269.65 74.9432 265.543 70.8359 260.477 70.8359Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.086 67.8281H114.898C109.832 67.8281 105.725 71.9354 105.725 77.002V173.854C105.725 178.92 109.832 183.027 114.898 183.027H264.086C269.152 183.027 273.26 178.92 273.26 173.854V77.002C273.26 71.9354 269.152 67.8281 264.086 67.8281Z",
    fill: "#1F1F1F",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.725 90.0859H273.26V196.111C273.26 201.178 269.152 205.285 264.086 205.285H114.898C109.832 205.285 105.725 201.178 105.725 196.111V90.0859Z",
    fill: "#4E95A4",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.711 83.7695C122.12 83.7695 124.072 81.8169 124.072 79.4082C124.072 76.9995 122.12 75.0469 119.711 75.0469C117.302 75.0469 115.35 76.9995 115.35 79.4082C115.35 81.8169 117.302 83.7695 119.711 83.7695Z",
    fill: "#FA6363",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M134.148 83.7695C136.557 83.7695 138.51 81.8169 138.51 79.4082C138.51 76.9995 136.557 75.0469 134.148 75.0469C131.74 75.0469 129.787 76.9995 129.787 79.4082C129.787 81.8169 131.74 83.7695 134.148 83.7695Z",
    fill: "#EEC94F",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.586 83.7695C150.995 83.7695 152.947 81.8169 152.947 79.4082C152.947 76.9995 150.995 75.0469 148.586 75.0469C146.177 75.0469 144.225 76.9995 144.225 79.4082C144.225 81.8169 146.177 83.7695 148.586 83.7695Z",
    fill: "#58BC7E",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1309 158.811L31.1309 211.146C31.1309 218.871 37.3928 225.133 45.1172 225.133H152.195C159.92 225.133 166.182 218.871 166.182 211.146V158.811C166.182 151.086 159.92 144.824 152.195 144.824H45.1172C37.3928 144.824 31.1309 151.086 31.1309 158.811Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7637 158.811L43.7637 211.146C43.7637 218.871 50.0256 225.133 57.75 225.133H155.805C163.529 225.133 169.791 218.871 169.791 211.146V158.811C169.791 151.086 163.529 144.824 155.805 144.824H57.75C50.0256 144.824 43.7637 151.086 43.7637 158.811Z",
    fill: "#4E95A4",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7637 159.863V212.5H169.791V159.863H43.7637Z",
    fill: "#E4FAFF",
    stroke: "black",
    strokeWidth: 0.902344
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4141 232.203H115.801M82.4141 240.023H99.8594",
    stroke: "black",
    strokeWidth: 0.902344,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1594 137.845C77.2015 138.055 77.3868 138.207 77.6016 138.207C77.8163 138.207 78.0016 138.055 78.0437 137.845L81.1532 122.406L96.342 119.248C96.5514 119.205 96.7012 119.02 96.7012 118.807C96.7012 118.593 96.5514 118.408 96.342 118.365L81.1532 115.207L78.0437 99.7684C78.0016 99.5578 77.8163 99.4062 77.6016 99.4062C77.3868 99.4062 77.2015 99.5578 77.1594 99.7684L74.0499 115.207L58.8613 118.365C58.652 118.408 58.502 118.593 58.502 118.807C58.502 119.02 58.652 119.205 58.8613 119.248L74.0499 122.406L77.1594 137.845ZM148.727 198.002C148.684 198.212 148.499 198.363 148.285 198.363C148.071 198.363 147.886 198.212 147.843 198.002L145.093 184.562L131.652 181.811C131.442 181.768 131.291 181.583 131.291 181.369C131.291 181.155 131.442 180.97 131.652 180.927L145.093 178.177L147.843 164.736C147.886 164.526 148.071 164.375 148.285 164.375C148.499 164.375 148.684 164.526 148.727 164.736L151.478 178.177L164.918 180.927C165.128 180.97 165.279 181.155 165.279 181.369C165.279 181.583 165.128 181.768 164.918 181.811L151.478 184.562L148.727 198.002Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.902344,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddScreenImage);
export default __webpack_public_path__ + "static/media/add-screen-image.15fe7b3031036212e890bcac31aa9d68.svg";
export { ForwardRef as ReactComponent };